import Fetch from "./index";

export const getAssistant = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/assistant/" + id)
}

export const getAssistantNativeClientPlatforms = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch(`/assistant/${id}/native-client-platform`)
}

export const createBooSession = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch(`/assistant/${id}/boo-sso`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
    })
}

export const getAssistants = async (filters) => {
    const filter = new URLSearchParams(filters).toString();
    return Fetch(`/assistant?${filter}`)
}

export const getAssistantStats = async () => {
    return Fetch('/assistant/stats')
}

export const updateAssistant = async (id, data) => {
    return Fetch(
        '/assistant/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const duplicateAssistant = async (id) => {
    return Fetch(
        '/assistant/' + id + "/duplicate",
        {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const deleteAssistant = async (id) => {
    return Fetch(
        '/assistant/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const createAssistant = async (data) => {
    data.isActive = false;

    return Fetch(
        '/assistant/',
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const getFiles = async ({assistantID, ...filters}) => {
    const filter = new URLSearchParams(filters).toString();
    return Fetch(`/assistant/${assistantID}/file/?${filter}`)
}

export const uploadAssistantFile = async ({ assistantID, file }) => {
    if (!assistantID || !file)
        return Promise.reject("cannot upload without assistant and file");

    const data = new FormData();
    data.append('doc', file);

    return Fetch(
        `/assistant/${assistantID}/file/`,
        {
            method: 'POST',
            body: data,
        },
    )
}

export const getFile = async ({assistantID, fileId}) => {
    if (!assistantID || !fileId)
        return;

    return Fetch(`/assistant/${assistantID}/file/${fileId}`)
}

export const getFileContent = async ({assistantID, fileId, ...filters}) => {
    if (!assistantID || !fileId)
        return;

    for (let key in filters) {
        if (!filters[key])
            delete filters[key];
    }

    const filter = new URLSearchParams(filters).toString();

    return Fetch(`/assistant/${assistantID}/file/${fileId}/content?`+filter)
}

export const deleteFile = async ({assistantID, fileId}) => {
    if (!assistantID || !fileId)
        return Promise.reject("cannot delete without necessary params");

    return Fetch(
        `/assistant/${assistantID}/file/${fileId}`,
        {method: 'DELETE'},
    )
}

export const updateFile = async ({assistantID, fileId, data}) => {
    if (!assistantID || !fileId || !data)
        return Promise.reject("cannot update without necessary params");

    return Fetch(
        `/assistant/${assistantID}/file/${fileId}`,
        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const createScrapWebsite = async ({assistantID, data}) => {
    return Fetch(
        `/assistant/${assistantID}/file/scraping`,
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const createTextData = async ({assistantID, data}) => {
    return Fetch(
        `/assistant/${assistantID}/file/text`,
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}
